<script setup>
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
</script>

<template>
  <section class="survey-info">
    <div class="info-block">
      <h3>{{ t('survey-secondary-section-why-title') }}</h3>
      <p>{{ t('survey-secondary-section-why-body') }}</p>
    </div>

    <div class="info-block">
      <h3>{{ t('survey-secondary-section-global-title') }}</h3>
      <p>
        <span class="global-lead">{{ t('survey-secondary-section-global-lead-1') }}</span>
        <span class="global-rest">{{ t('survey-secondary-section-global-part-1') }}</span>
        <span class="global-lead">{{ t('survey-secondary-section-global-lead-2') }}</span>
        <span class="global-rest">{{ t('survey-secondary-section-global-part-2') }}</span>
        <span class="global-lead">{{ t('survey-secondary-section-global-lead-3') }}</span>
        <span class="global-rest">{{ t('survey-secondary-section-global-part-3') }}</span>
      </p>
    </div>

    <div class="info-block">
      <h3>{{ t('survey-secondary-section-lack-title') }}</h3>
      <p>{{ t('survey-secondary-section-lack-body') }}</p>
    </div>

    <div class="info-block">
      <h3>{{ t('survey-secondary-section-participate-title') }}</h3>
      <p>
        <span>{{ t('survey-secondary-section-participate-line-1-prefix') }}</span>
        <a
          class="survey-link"
          :href="t('survey-secondary-section-participate-url')"
          target="_blank"
          rel="noopener noreferrer"
        >
          {{ t('survey-secondary-section-participate-url') }}
        </a>
        <br />
        <span>{{ t('survey-secondary-section-participate-line-2') }}</span>
        <br />
        <span>{{ t('survey-secondary-section-participate-line-3') }}</span>
      </p>
    </div>
  </section>
</template>

<style scoped lang="scss">
.survey-info {
  display: flex;
  flex-direction: column;
  gap: 2rem;
  border-radius: 1.5rem;

  .info-block {
    border-radius: 1.5rem;
    padding: 1.5rem;
    text-align: left;
    color: $color-purple;
    background-color: $color-pink-lighter;

    h3 {
      font-size: $font-size-md;
      margin-bottom: 1rem;
    }

    p {
      font-size: $font-size-sm;
    }

    .survey-link {
      color: inherit;
      text-decoration: underline;
      word-break: break-all;
    }

    .global-lead {
      display: inline-block;
      margin-right: 3px;
      font-size: $font-size-md;
      font-weight: 700;
      line-height: 1;
    }
  }
}
</style>
